import { icons } from "../../assets";
import { formatPrice } from "../../shop/formatPrice";

function WebshopComingSoon({ t, lang, coffeePriceHuf }) {
  const coffeeAvailable = coffeePriceHuf > 0;

  return (
    <section className="shop-soon">
      <div className="shop-soon-glow" aria-hidden="true" />

      <div className="container shop-soon-inner">
        <div className="shop-soon-copy">
          <p className="shop-soon-eyebrow">{t.eyebrow}</p>
          <h1 className="shop-soon-title">
            {t.title}
            <span className="shop-soon-dots" aria-hidden="true">
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </span>
          </h1>
          <p className="shop-soon-text">{t.text}</p>

          {coffeeAvailable ? (
            <a className="shop-soon-available" href={`/checkout?lang=${lang}`}>
              <img src={icons.coffee} alt="" className="shop-soon-available-thumb" />
              <span className="shop-soon-available-copy">
                <span className="shop-soon-available-badge">{t.availableBadge}</span>
                <span className="shop-soon-available-title">{t.availableTitle}</span>
                <span className="shop-soon-available-meta">{t.availableMeta}</span>
              </span>
              <span className="shop-soon-available-side">
                <span className="shop-soon-available-price">{formatPrice(coffeePriceHuf)}</span>
                <span className="shop-soon-available-cta">
                  {t.availableCta} <span aria-hidden="true">→</span>
                </span>
              </span>
            </a>
          ) : null}
        </div>

        <div className="shop-soon-visual" aria-hidden="true">
          <svg className="shop-soon-ring" viewBox="0 0 200 200">
            <defs>
              <path id="shop-soon-circle" d="M100,100 m-82,0 a82,82 0 1,1 164,0 a82,82 0 1,1 -164,0" />
            </defs>
            <text>
              {/* Circumference 2π·82 ≈ 515: stretch the text to close the circle exactly. */}
              <textPath href="#shop-soon-circle" textLength="512" lengthAdjust="spacing">
                {t.ringText}
              </textPath>
            </text>
          </svg>
          <div className="shop-soon-steam">
            <span />
            <span />
            <span />
          </div>
          <div className="shop-soon-bag-wrap">
            <img className="shop-soon-bag" src={icons.coffee} alt="" />
            {coffeeAvailable ? <span className="shop-soon-sticker">{t.bagSticker}</span> : null}
          </div>
          <div className="shop-soon-shadow" />
        </div>
      </div>
    </section>
  );
}

export default WebshopComingSoon;
